<template>
    <div>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                    color="info"
                    fab
                    x-small
                    v-on="on"
                    :to="
                        '/Project/ViewCasepending/Nonhp/' +
                            maincaseid +
                            '/' +
                            'ViewDetail'
                    "
                    target="_blank"
                >
                    <v-icon small>mdi-magnify</v-icon>
                </v-btn>
            </template>
            <span>View Case</span>
        </v-tooltip>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

export default {
    props: ["maincaseid"],
    data() {
        return {
            direction: "left",
            transition: "slide-y-reverse-transition",
        }
    },
}
</script>
